export { SliderCard, type SliderCardProps } from "@shared/ui/slider-card";
